
/* injects from baggage-loader */

'use strict';

export default class AccountCodesController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account/codes/account.codes.controller.js